import { createSelector } from 'reselect';
import { getCurrentSelection } from 'src/features/users/utils/UsersDataUtils';
import { ACTION } from 'src/constants';
import _ from 'lodash';
import { searchList } from 'src/services/UsersService';

export const selectedIdsMemoized = createSelector(
    getCurrentSelection(['usersSearchText'], ACTION.TYPE_DEFAULT),
    getCurrentSelection(['usersWithConnectedApps'], ACTION.TYPE_ARRAY),
    getCurrentSelection(['selectedIds', 'filteredUsersToShow'], ACTION.TYPE_ARRAY),
    (selectedSearchText, SelectedUsers, selectedIds) => {
        return selectedSearchText
            ? searchList(SelectedUsers, selectedSearchText)
                  .filter(x => selectedIds?.includes(x?.id))
                  .map(v => v?.id)
            : selectedIds;
    }
);

export const selectedActiveIdsMemoized = createSelector(
    getCurrentSelection(['usersWithConnectedApps'], ACTION.TYPE_ARRAY),
    selectedIdsMemoized,
    (SelectedUsers, selectedIds) => {
        return SelectedUsers?.filter(u => !u?.isPending && !u?.isDisabled && selectedIds?.indexOf(u?.id) > -1).map(
            v => v?.id
        );
    }
);

export const selectedDisabledIdsMemoized = createSelector(
    getCurrentSelection(['usersWithConnectedApps'], ACTION.TYPE_ARRAY),
    selectedIdsMemoized,
    (SelectedUsers, selectedIds) => {
        return _.filter(SelectedUsers, user => _.indexOf(selectedIds, user.id) > -1 && user.status === 'disabled');
    }
);

export const selectedPendingIdsMemoized = createSelector(
    getCurrentSelection(['usersWithConnectedApps'], ACTION.TYPE_ARRAY),
    selectedIdsMemoized,
    (SelectedUsers, selectedIds) => {
        return SelectedUsers?.filter(u => u?.isPending && selectedIds?.indexOf(u?.id) > -1).map(v => v?.id);
    }
);

export const selectedUsersMemoized = createSelector(
    getCurrentSelection(['usersWithConnectedApps'], ACTION.TYPE_ARRAY),
    selectedIdsMemoized,
    (SelectedUsers, selectedIds) => {
        return SelectedUsers?.filter(x => selectedIds.includes(x.id));
    }
);

export default selectedIdsMemoized;
